
import { useState } from "react";

export const useProfileValidation = () => {
  const [validationError, setValidationError] = useState("");

  const validateDisplayName = (name: string): boolean => {
    if (!name || name.trim().length === 0) {
      setValidationError("Display name is required");
      return false;
    }
    if (name.trim().length < 3) {
      setValidationError("Display name must be at least 3 characters long");
      return false;
    }
    if (name.trim().length > 30) {
      setValidationError("Display name must be less than 30 characters");
      return false;
    }
    setValidationError("");
    return true;
  };

  return {
    validationError,
    setValidationError,
    validateDisplayName
  };
};
